import store from './store/store';
import {
    FirebaseContext,
    FirebaseProvider,
    firebase
} from './config/configureFirebase';
import * as authactions from './actions/authactions';
import * as bookingactions from './actions/bookingactions';
import * as bookinglistactions from './actions/bookinglistactions';
import * as cancelreasonactions from './actions/cancelreasonactions';
import * as cartypeactions from './actions/cartypeactions';
import * as estimateactions from './actions/estimateactions';
import * as driverearningaction from './actions/driverearningaction';
import * as earningreportsaction from './actions/earningreportsaction';
import * as notificationactions from './actions/notificationactions';
import * as promoactions from './actions/promoactions';
import * as usersactions from './actions/usersactions';
import * as settingsactions from './actions/settingsactions';
import * as paymentactions from './actions/paymentactions';
import * as tripactions from './actions/tripactions';
import * as taskactions from './actions/taskactions';
import * as locationactions from './actions/locationactions';
import * as chatactions from './actions/chatactions';
import * as withdrawactions from './actions/withdrawactions';
import * as DateFunctions from './other/DateFunctions';
import * as timezone from './other/timezone';
import * as SurchargeFunctions from './other/SurchargeFunctions';
import * as GoogleAPIFunctions from './other/GoogleAPIFunctions';
import { FareCalculator } from './other/FareCalculator';
import { AdvancedFareCalculator } from './other/AdvancedFareCalculator';
import { calculateEarnings } from './other/EarningsCalculator';
import * as GeoFunctions from './other/GeoFunctions';
import * as languageactions from './actions/languageactions';
import * as addressactions from './actions/addressactions';
import * as NotificationFunctions from './other/NotificationFunctions';
import * as caractions from './actions/caractions';
import * as smtpactions from './actions/smtpactions';
import * as smsactions from './actions/smsactions';
import countries from './other/GetCountries';
import * as sosctions from './actions/sosaction';
import * as complainactions from './actions/complainactions';
import * as usedreferralaction from "./actions/usedreferralaction";
import * as fetchFleetAdminEarnings from "./actions/fleetadminearningaction";
import * as zonesactions from "./actions/zonesactions";
import * as vietnameseFunctions from './other/vietnameseFunctions';
import { normalizeBookingPayload } from './booking/utils/normalizeBookingPayload';
import { stripUndefinedDeep } from './booking/utils/stripUndefinedDeep';
import * as authHelpers from './other/authHelpers';

const api = {
    ...authactions,
    ...bookingactions,
    ...authHelpers,
    ...bookinglistactions,
    ...cancelreasonactions,
    ...cartypeactions,
    ...estimateactions,
    ...driverearningaction,
    ...earningreportsaction,
    ...notificationactions,
    ...promoactions,
    ...usersactions,
    ...settingsactions,
    ...paymentactions,
    ...tripactions,
    ...taskactions,
    ...locationactions,
    ...addressactions,
    ...chatactions,
    ...withdrawactions,
    ...DateFunctions,
    ...timezone,
    ...SurchargeFunctions,
    ...GoogleAPIFunctions,
    FareCalculator,
    AdvancedFareCalculator,
    calculateEarnings,
    ...GeoFunctions,
    ...languageactions,
    ...NotificationFunctions,
    ...caractions,
    ...complainactions,
    ...smtpactions,
    ...smsactions,
    ...sosctions,
    ...usedreferralaction,
    ...fetchFleetAdminEarnings,
    ...zonesactions,
    ...vietnameseFunctions,
    countries: countries,
    normalizeBookingPayload,
    stripUndefinedDeep
};

export * from './other/DateFunctions';
export * from './other/GeoFunctions';

export {
    FirebaseContext,
    FirebaseProvider,
    store,
    api,
    firebase
}